module.exports = __webpack_public_path__ + "img/menu.e1178e57.svg";